export * from './HomeModule'
export const homePath = '/et/company/:companyId'
